export default {"src":"/_next/static/media/integration-with-email-security-solution.f9e9b3c6.svg","height":240,"width":290,"blurWidth":0,"blurHeight":0};